"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get UserActionRecord () {
        return UserActionRecord;
    },
    get UserParticipantRecord () {
        return UserParticipantRecord;
    },
    get UserParticipantRecordExtended () {
        return UserParticipantRecordExtended;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const UserParticipantRecord = _zod.z.object({
    role: _models.MeetingParticipantRolesSchema,
    userId: _utilsisomorphic.transformObjectId
});
const UserParticipantRecordExtended = UserParticipantRecord.extend({
    name: _zod.z.string()
});
const UserActionRecord = _zod.z.object({
    userId: _utilsisomorphic.transformObjectId,
    timeStamp: _zod.z.instanceof(Date),
    name: _zod.z.string().optional()
});
